export const translation = {
  SEARCH_CATALOG: "Rechercher dans le catalogue",
  MY_SETUP: "Mes paramètres",
  CONTACT_US: "Nous contacter",
  HELP: "Aide",
  LOGOUT: "Déconnexion",
  ORDER_FAVORITES: "Commande des favoris",
  QUICK_ORDER: "Commande rapide",
  ORDER_BANDS: "Commande de bagues",
  CATALOG: "Catalogue",
  SAVED_CARTS: "Paniers sauvegardés",
  MY_CART: "Mon panier",
  MY_ORDERS: "Mes commandes",
  MY_STATEMENT: "Mes relevés",
  WELCOME: "Bienvenue",
  LOGIN_ID: "Identifiant de connexion",
  ACCOUNT_NUMBER: "Numéro de compte",
  ADDRESS: "Adresse",
  PHONE: "Téléphone",
  FAX: "Fax",
  PRICE_DISCOUNT: "Remise de prix",
  SHOW_CUSTOMER_DETAILS: "Afficher les détails du client",
  HIDE_CUSTOMER_DETAILS: "Masquer les détails du client",
  MY_REWARDS: "Mes récompenses",
  PRODUCTS: "Produits",
  YOUR_PRODUCTS: "Mes produits", // => needs to be verified
  MANAGE_ACCOUNTS: "Gérer les comptes", // => needs to be verified
  //CATALOG PAGE
  PRODUCTS: "Produits",
  HOME: "Accueil",
  //Saved Carts
  CART_NUMBER: "Référence du panier",
  CART_NAME: "Nom du panier",
  LAST_UPDATED: "Dernière mise à jour",
  TOTAL: "Total",
  ACTIONS: "Actions",
  SAVED_CARTS: "Paniers sauvegardés",
  CREATE_CART: "Créer un panier",
  VIEW_CART_DETAILS: "Afficher les détails du panier",
  SET_AS_CURRENT_CART: "Définir comme panier actuel",
  RENAME_CART: "Renommer le panier",
  DELETE_CART: "Supprimer le panier",
  ACTIVE_CART_MESSAGE: "Ceci est votre panier actif.",
  LOCK_CART_MESSAGE: "Ce panier est verrouillé par l’identifiant de connexion",
  RENAME: "Renommer",
  DELETE: "Supprimer",
  CANCEL: "Annuler",
  PRIVATE_CART_MESSAGE:
    "Ce panier est privé. Déverrouillez-le pour permettre à d’autres personnes de voir ce panier.", //BOB
  UNLOCK_CART: "Déverrouiller le panier", //BOB
  TAKE_OVER_LOCK: "Verrou de re", //=> needs to be verified
  LOCK_CART: "Verrouiller le panier",
  CART_NAME: "Nom du panier",
  LOCK_CART_SELF_MESSAGE:
    "Vous avez verrouillé ce panier. Personne d’autre ne peut le modifier.",
  CREATE: "Créer", //=> needs to be verified,
  CUSTOMER_SUPPORT: "Soutien à la clientèle", //=> needs to be verified
  YOUR_ACCOUNT: "Mon compte", //=> needs to be verified
  ITEMS: "Articles", //=> needs to be verified
  //Product Details Page
  OVERVIEW: "Présentation",
  SPECIFICATIONS: "Caractéristiques",
  DETAILS: "Détails",
  VIEW_LEGAL_DISCLAIMER: "Afficher la clause de non-responsabilité",
  PRODUCTS_AVAILABLE: "Produits disponibles",
  THREEM_SITE_REDIRECT_MSG: "Cliquez ici pour voir ce produit sur Solventum.com", //=> needs to be verified
  LEGAL_DISCLAIMER: "Clause de non-responsabilité",
  ENDORSEMENT_MSG:
    "*Version Solventum de cette prescription. Aucune approbation par le médecin n’est implicite.", //=> needs to be verified
  SEARCH_RESULTS_FOR: "Résultat de la recherche pour",
  CATALOG_PRODUCT: "Catalogue",
  SEARCH_RESULTS: "Résultat de la recherche...",
  //My Rewards Page
  SAVINGS_THIS_YEAR: "d’économie cette année",
  CURRENT_3M: "État actuel des remises cumulées sur les aligneurs",
  TM: "TM",
  CLARITY: "Solventum Clarity",
  DISCOUNT_STATUS: "",
  CLARITY_ALIGNERS_CASES: "Boîtiers d’aligneurs Clarity",
  OTHER_PRODUCT_PURCHASES: "Autres achats de produits",
  SPEND: "Dépensez",
  IN_PRODUCT_PURCHASES: "dans l’achat de produits",
  ADD: "Ajouter", //=> Needs to be verified
  OR: "OU",
  CLARITY_ALIGNERS_ORDERS: "Commandes d’aligneurs Clarity",
  DATE: "Date",
  INVOICE_NUMBER: "Numéro de facture",
  ORDER_NUMBER: "Numéro de commande",
  QUALIFYING_CASES: "Boîtes admissibles",
  QUALIFYING_PURCHASES: "Achats admissibles", //=> needs to be verified
  OTHER_ORTHODONTIC_PURCHASES: "Autres achats orthodontiques",
  FAQS: "FAQ",
  //MAC BOB
  BUYING_FOR: "Achat pour",
  BUY_ON_BEHALF: "Acheter pour le compte de",
  RETURN_TO_HEADQUARTERS: "Retour au siège",

  //Shopping cart
  SHOPPING_CART: "Caddie",
  PRINT_QUOTE: "Imprimer le devis",
  CART_LOCKED: "Panier verrouillé",
  CART_UNLOCKED: "Panier déverrouillé",
  SELECT_ITEMS: "Sélectionnez le(s) élément(s) à",
  APPLY_A_DISCOUNT: "Appliquer une réduction",
  APPLY_DISCOUNT: "Appliquer une réduction",
  DELETE: "Supprimer",
  ESTIMATED_SUBTOTAL: "Sous-total estimatif",
  ITEMS: "Articles",
  SHIPPING_MESSAGE:
    "Les frais d’expédition et les taxes seront estimés après votre commande",
  PROCEED_TO_CHECKOUT: "Passer à la caisse",
  NET_PRICE_DESCRIPTION:
    "Votre prix net comprend votre programme de tarification personnalisé",
  TYPE: "Type",
  SIZE: "Taille",
  QUANTITY: "Quantité",
  EDIT_ORDER: "Modifier la commande",
  COMMENTS: "Commentaires",
  CART_EMPTY_MESSAGE: "Votre panier est vide!",
  SHOP_YOUR_FAVORITES: "Magasinez vos favoris",
  SHOP_ORDER_HISTORY: "Historique des commandes en boutique",
  LOADING_YOUR_CART: "Chargement de votre panier...",
  THE_ORDER_IS_LOCKED: "La commande est verrouillée. Pour modifier la commande, contactez votre représentant Solventum sur le terrain répertorié sur la page Contactez-nous.",
  THE_ORDER_IS_UNLOCK: "La commande est déverrouillée, cliquez sur Verrouiller pour modifier la commande.",
  TO_APPLY_A_DISCOUNT: "Pour appliquer une réduction, sélectionnez un ou plusieurs produits et un code de réduction.",

  //Checkout page
  CHECKOUT: "Vérifier",
  PLACE_ORDER: "Passer la commande",
  SHIPPING_CONTACT_INFO_HEADER: "Informations d'expédition et de contact",
  PLACING_ORDER_HEADER: "Qui passe cette commande ?",
  SHIPPING_ADDRESS: "Adresse de livraison",
  PRIMARY_CONTACT_INFO_HEADER: "Coordonnées principales",
  CONFIRMATION_HEADER:
    "Souhaitez-vous envoyer un e-mail de confirmation à quelqu'un d'autre ?",
  RECIPIENT_EMAIL_HEADER: "Courriel du ou des destinataires",
  ENTER_EMAIL: "Entrez l'e-mail",
  ADD_RECIPIENT: "Ajouter un destinataire",
  ADD_RECIPIENT_EMAIL_MESSAGE:
    "Veuillez ajouter l'adresse e-mail du destinataire",
  VALID_EMAIL_ADDRESS_MESSAGE: "Veuillez entrer une adresse e-mail valide",
  PAYMENT_INFO_HEADER: "Informations de paiement",
  CARD: "Carte",
  ACH: "ACH",
  BILL_MY_ACCOUNT: "Facturer mon compte",
  YOUR_CARDS: "Vos cartes",
  EXPIRES: "Expire",
  NO_CARD_MESSAGE: "Vous n'avez actuellement aucune carte dans votre dossier.",
  ADD_CARD_MESSAGE:
    "Ajoutez une carte ou sélectionnez un autre mode de paiement pour passer votre commande.",
  ADD_NEW_CARD: "Ajouter une nouvelle carte",
  ADD_CARD: "Ajouter une carte",
  ACH_PAYMENT_HEADER: "Vos options de paiement ACH",
  NO_ACH_MESSAGE:
    "Vous n'avez actuellement aucun mode de paiement ACH configuré.",
  ADD_ACH_MESSAGE:
    "Ajoutez un compte ACH ou sélectionnez un autre mode de paiement pour passer votre commande.",
  ADD_NEW_ACH: "Ajouter un nouvel ACH",
  ADD_ACH: "Ajouter ACH",
  PAYMENT_TERMS: "Modalités de paiement",
  DEFAULT_PAYMENT_METHOD: "Méthode de paiement par défaut",
  BILLING_ADDRESS: "adresse de facturation",
  NO_BILL_MY_ACCOUNT_MESSAGE:
    "Vous n'êtes actuellement pas configuré pour la facturation du compte.",
  CUSTOMER_SERVICE_MESSAGE:
    "Contactez le service client ou sélectionnez un autre mode de paiement pour passer votre commande.",
  REVIEW_PURCHASE_HEADER: "Vérifier l'achat",
  PO_NUMBER_LABEL:
    "Avez-vous un numéro de bon de commande pour cette commande ?",
  SPECIAL_INSTRUCTIONS_LABEL:
    "Avez-vous des instructions particulières pour cette commande ?",
  CHARACTER_LIMIT_MESSAGE: "Veuillez saisir jusqu'à 255 caractères.",
  CHARACTERS_LEFT: "Caractères restants:",
  REVIEW_ITEMS_MESSAGE:
    "Examinez les articles une dernière fois avant de passer votre commande.",
  UNIT_PRICE: "Prix unitaire",
  LIST_PRICE: "Prix catalogue",
  LIST_UNIT_PRICE: "Prix unitaire catalogue",
  NET_UNIT_PRICE: "Prix unitaire net",
  NET_PRICE: "Prix net",
  TOTAL_PRICE: "Prix unitaire total",
  CUSTOM_BANDS_HEADER: "Bandes soudées sur mesure (bandes de prescription)",
  EDIT_ITEMS_MESSAGE: "Modifier les articles dans le panier",
  EMAIL_VALIDATION_MESSAGE:
    "Veuillez entrer votre email pour passer votre commande.",
  PAYMENT_VALIDATION_MESSAGE:
    "Veuillez sélectionner le mode de paiement pour passer votre commande.",
  PAYMENT_METHOD_NOT_AVAILABLE_MESSAGE:
    "Ce mode de paiement n'est pas disponible pour ce compte. Sélectionnez un autre mode de paiement ou contactez le service client.",
  PAYMENT_SETUP_INIT_FAILED_MESSAGE:
    "Impossible d'initialiser la configuration du paiement pour ce compte. Sélectionnez un autre mode de paiement ou contactez le service client.",
  ENTER_PO_NUMBER: "Entrez le numéro de bon de commande",
  DESCRIBE_YOUR_REQUEST: "Décrivez votre demande ici...",
  PREPARING_YOUR_ORDER: "Préparation de votre commande...",
  RESTORE_DEFAULT_RECIPIENT: "Retablir le destinataire par defaut",
};
